import AppStore from 'assets/app-store.svg'
import GoogleStore from 'assets/play-store.svg'
import imgLeft from 'assets/app-download-img-left.png'
import imgRight from 'assets/app-download-img-right.png'
import './index.scss'

interface Props { }

export function BannerSection(props: Props) {
    return (
        <div className="bg-banner">
            <div className="max-width p-x">
                <div className="bannerSection" id="downloadApp">
                    <div className="bannerSection-left desktop">
                        <img src={imgLeft} alt="Left" />
                    </div>
                    <div className="bannerSection-center">
                        <h2 className="bannerSection-center-head">Get Your Daily Needs From Our KachaBazar Store</h2>
                        <p className="bannerSection-center-body">
                            There are many products you will find our shop, Choose your daily necessary product from our KachaBazar shop and get some special offer.
                        </p>
                        <div className="bannerSection-center-store">
                            <div className="bannerSection-center-store-apple">
                                <img src={AppStore} alt="Apple" />
                            </div>
                            <div className="bannerSection-center-store-g_play">
                                <img src={GoogleStore} alt="GooglePlay" />
                            </div>
                        </div>
                    </div>
                    <div className="bannerSection-right desktop">
                        <img src={imgRight} alt="Right" />
                    </div>
                </div>
            </div>
        </div>
    )
}
